<template>
  <b-modal
    centered
    :visible="show"
    size="lg"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-info">{{ $t("globals.create_synatec_order") }}:</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            small
            :items="orderItemsWithSinatecItems"
            :fields="fields"
          >
            <template v-slot:row-details="row">
              <ul style="margin-top: -10px;">
                <li v-for="synatecProduct in row.item.billing_item.synatec_products" :key="synatecProduct.id">
                  <span class="text-secondary small">{{ `${synatecProduct.name} - ${synatecProduct.synatec_code}` }}</span>
                </li>
              </ul>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <hr />
      <!-- Address / Notes -->
      <b-row>
        <b-col>
          <h6 class="text-info">{{ $t("globals.send_to") }}:</h6>
        </b-col>
      </b-row>
      <b-row class="bg-light p-2 rounded">
        <b-col>
          <span class="text-secondary small">{{ $t("globals.prefill_data") }}:</span>
        </b-col>
        <b-col v-for="(dataSet, key) in prefillData" :key="key">
          <b-btn class="float-right" size="sm" variant="info" @click="prefillDataSet(dataSet)" >
            {{ key.replace('_', ' ').toUpperCase() }}
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span>{{ $t("globals.first_name") }}:</span>
          <span class="float-right">{{ $t("globals.last_name") }}:</span>
          <b-input-group>
            <b-form-input v-model="order.customer.shipping_first_name" />
            <b-form-input v-model="order.customer.shipping_last_name" />
          </b-input-group>
          <span>{{ $t("globals.address") }}:</span>
          <b-form-input v-model="order.customer.shipping_address" />
          <span>{{ $t("globals.city") }}:</span>
          <b-form-input v-model="order.customer.shipping_city" />
          <span>{{ $t("globals.postal_code") }}:</span>
          <span class="float-right">{{ $t("globals.country") }}:</span>
          <b-input-group>
            <b-form-input v-model="order.customer.shipping_postal_code" />
            <b-form-input v-model="order.customer.shipping_country" />
          </b-input-group>
        </b-col>
        <b-col>
          <span>{{ $t("globals.email") }}:</span>
          <b-form-input v-model="order.customer.shipping_email" />
          <label> {{ $t("globals.notes") }}: </label>
          <b-form-textarea v-model="notes" rows="6"></b-form-textarea>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn size="sm" @click="close" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn
            size="sm"
            class="float-right"
            variant="success"
            @click="save"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    order: Object,
    prefillData: Object
  },
  data() {
    return {
      orderItemsWithSinatecItems: [],
      toFleetprint: false,
      notes: "",
      fields: [
        {
          key: "item_name",
          label: this.$t("globals.item_name")
        },
        {
          key: "quantity",
          label: this.$t("globals.quantity")
        }
      ],
      
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    save() {
      let variables = {
        synatec_order: {
          order_id: parseInt(this.$route.params.id),
          customer_id: this.order.customer.id,
          notes: this.notes,
          shipping_first_name: this.order.customer.shipping_first_name,
          shipping_last_name: this.order.customer.shipping_last_name,
          shipping_email: this.order.customer.shipping_email,
          shipping_address: this.order.customer.shipping_address,
          shipping_city: this.order.customer.shipping_city,
          shipping_postal_code: this.order.customer.shipping_postal_code,
          shipping_country: this.order.customer.shipping_country,
          items: []
        }
      };

      this.order.order_items.forEach((oi) => {
        oi.billing_item.synatec_products.forEach((sp) => {
          variables.synatec_order.items.push({
            name: sp.name,
            synatec_code: sp.synatec_code,
            quantity: oi.quantity
          });
        });
      });

      let data = {
        query: `
          mutation SynatecOrderCreate ($synatec_order: SynatecOrderInput) {
            res: SynatecOrderCreate (synatec_order: $synatec_order) {
              id
            }
          }
        `,
        variables
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.close();
      });
    },

    prefillDataSet(dataSet) {
      this.order.customer.shipping_first_name = dataSet.firstName;
      this.order.customer.shipping_last_name = dataSet.lastName;
      this.order.customer.shipping_email = dataSet.email;
      this.order.customer.shipping_address = dataSet.address;
      this.order.customer.shipping_city = dataSet.city;
      this.order.customer.shipping_postal_code = dataSet.postalCode;
      this.order.customer.shipping_country = dataSet.country;
    },

  },
  computed: {
    saveDisabled() {
      return (
        this.order.customer.shipping_first_name.length == 0 ||
        this.order.customer.shipping_last_name.length == 0 ||
        this.order.customer.shipping_email.length == 0 ||
        this.order.customer.shipping_address.length == 0 ||
        this.order.customer.shipping_city.length == 0 ||
        this.order.customer.shipping_postal_code.length == 0 ||
        this.order.customer.shipping_country.length == 0 ||
        this.orderItemsWithSinatecItems.length == 0
      );
    }
  },
  watch: {
    "show": function(val) {
      if (val) {
        this.orderItemsWithSinatecItems = this.order.order_items.filter(oi => {
          if (oi.billing_item) {
            return oi.billing_item.synatec_products.length > 0;
          }
          return false;
        });
      }
    }
  }
};
</script>
